/*=============================================
=            Basic Identifier Styling         =
=============================================*/
@import './pk-identifier.variables';

:host {
  @apply block;
}

.pk-identifier {
  @apply box-border flex w-full min-w-0 items-center bg-[color:--identifier--bg-color] px-0 py-0;

  &.horizontal {
    ::slotted([slot='prefix']) {
      @apply mr-xs;
    }
  }

  &.rounded {
    @apply rounded-[--identifier--border-radius];
  }

  &.vertical {
    @apply flex-col;

    ::slotted([slot='suffix']) {
      @apply ml-0 mt-xs;
    }

    ::slotted([slot='prefix']) {
      @apply mb-xs;
    }
  }

  &.vertical.alignment--left {
    @apply items-start;
  }

  &.vertical.alignment--right {
    @apply items-end;
  }

  &.vertical.alignment--center {
    @apply items-center;
  }

  &.selectable {
    @apply relative cursor-pointer rounded-[--identifier--border-radius] p-[--identifier--pad] has-[:focus-visible]:focus-outline;
  }

  &.selectable.selected {
    @apply p-[calc(var(--identifier--pad)_-_1px)];

    border: var(--identifier--border);
  }

  &.inverted .content {
    @apply flex-col-reverse;
  }

  &.alignment--left .content {
    @apply mr-auto text-left;
  }

  &.alignment--right .content {
    @apply ml-auto text-right;
  }

  &.alignment--center .content {
    @apply mx-auto my-0 text-center;
  }

  .prefix,
  .suffix,
  ::slotted([slot='prefix']),
  ::slotted([slot='suffix']) {
    @apply inline-flex items-center;
  }

  ::slotted([slot='suffix']) {
    @apply ml-xs;
  }

  .primary {
    @apply overflow-x-clip text-ellipsis whitespace-nowrap text-[length:--identifier-primary--size] leading-[--identifier-primary--line-height] text-[color:--identifier-primary--color];

    font-family: var(--identifier-primary--font);
  }

  .primary.multi-row {
    @apply whitespace-normal;
  }

  .secondary {
    @apply overflow-x-clip text-ellipsis whitespace-nowrap text-[length:--identifier-secondary--size] leading-[--identifier-secondary--line-height] text-[color:--identifier-secondary--color];

    font-family: var(--identifier-secondary--font);

    &.vertical {
      @apply text-center;
    }
  }
}
